/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { Button } from './ui/button';

import Card from './Card';
import Store from './Store';
import VerifyAccount from './VerifyAccount';
import { STRIPEKEY, PRODUCT } from '../const';
import useCurrentUser from './useCurrentUser';

let Subscribe = ({ viewer, match, location }) => {
  const [currentUser] = useCurrentUser();

  React.useEffect(() => {
    let search = new URLSearchParams(location.search);
    let success = search.get('stripe_success');
    if (success) {
      Store.setSuccess("You've subscribed!");
    }
  }, [location.search]);

  let onCheckout = () => {
    let stripe = window.Stripe(STRIPEKEY);
    stripe
      .redirectToCheckout({
        items: [{ plan: PRODUCT, quantity: 1 }],

        // Do not rely on the redirect to the successUrl for fulfilling
        // purchases, customers may not always reach the success_url after
        // a successful payment.
        // Instead use one of the strategies described in
        // https://stripe.com/docs/payments/checkout/fulfillment
        successUrl: `${window.location.protocol}//${window.location.host}/subscribe?stripe_success=true`,
        cancelUrl: `${window.location.protocol}//${window.location.host}/subscribe`,
        customerEmail: currentUser.email,
      })
      .then(function(result) {
        if (result.error) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer.
          return Store.onFailure(result.error.message);
        }
      });
  };

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        {currentUser.isAnonymous && (
          <Card className="p-4">
            <h2 className="text-2xl font-semibold mb-2">Finish Setup</h2>
            <p className="text-sm mb-4">
              Choose an account provider before you can subscribe
            </p>
            <VerifyAccount
              message="In order to subscribe you must verify your email."
              params="redirect%3D%2Fsubscribe"
            />
          </Card>
        )}
      </div>
      {viewer.subscribed === 'limited' ? (
        <div className="col-span-12">
          <Card className="p-4">
            <h2 className="text-2xl font-semibold mb-2">Subscribe</h2>
            <p className="text-sm mb-4">
              You have used {viewer.messageCount} of your 100 free messages. For
              $12/year you'll get unlimited messages.
            </p>
            <div>
              <Button
                id="checkout-button-plan_FRtMPFn7UEkpvd"
                role="link"
                className="mt-2 mb-2"
                disabled={currentUser.isAnonymous}
                onClick={onCheckout}
              >
                Subscribe
              </Button>
            </div>
            <p className="text-sm mt-4">
              Your payments will be handled by redirecting to{' '}
              <a href="https://stripe.com" className="text-primary underline">
                Stripe.com
              </a>
              . Your credit card details go through their secure payment system.
            </p>
            <div id="error-message"></div>
          </Card>
        </div>
      ) : (
        <div className="col-span-12">
          <Card className="p-4">
            <h2 className="text-2xl font-semibold mb-2">Subscribed</h2>
            <p className="text-sm">
              You are currently subscribed and get unlimited messages. To
              unsubscribe email support@pushback.io
            </p>
          </Card>
        </div>
      )}
    </div>
  );
};

Subscribe = createFragmentContainer(Subscribe, {
  viewer: graphql`
    fragment Subscribe_viewer on User {
      id
      email
      subscribed
      messageCount
    }
  `,
});

export default Subscribe;
